import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCol,
    MDBIcon,
    MDBRow
  } from 'mdb-react-ui-kit';
  import axios from 'axios';
  import React, { useCallback, useEffect, useState } from 'react';
  
  const Pricing = () => {
    const [pricingData, setPricingData] = useState([]);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const fetchItems = useCallback(async () => {
      
      try {
        const  response = await axios.get(`${baseUrl}/pricing/host`);
        setPricingData(response.data); // Update the state with fetched data
        console.log('Get successful:', response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }, [baseUrl]); // Empty dependency array to run once on component mount
  
    useEffect(() => {
      fetchItems();
    }, [fetchItems]);
  
    return (
      <section className="text-center my-5">
        <h2 className="h1-responsive font-weight-bold text-center text-black my-5">
          {pricingData?.title}
        </h2>
        <p className="grey-text text-center w-responsive mx-auto mb-5"></p>
        <MDBRow className="align-items-center justify-content-center">
          {pricingData?.prices?.map((pricingObject, index) => (
            <MDBCol lg="4" md="12" className="mb-lg-0 mb-4" key={index}>
              <MDBCard className="text-light">
                <MDBCardHeader className="text-black">
                  <h4
                    className="option"
                    style={{
                      padding: "2.5rem",
                      marginBottom: 0,
                      fontWeight: 500
                    }}
                  >
                    {pricingObject.type}
                  </h4>
                  <MDBBtn block color={pricingObject.color} >
                    Buy now
                  </MDBBtn>
                </MDBCardHeader>
                <MDBCardBody className="striped green-striped text-black px-5">
                  <h2 className="my-4 pb-3 h1">{pricingObject.price}</h2>
  
                  {pricingObject.features.map((feature, featureIndex) => (
                    <p key={featureIndex} style={{ textAlign: 'left' }}>
                      <MDBIcon fas icon={feature.icon} className="me-4" />
                      {feature.textValue}
                    </p>
                  ))}
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          ))}
        </MDBRow>
      </section>
    );
  };
  
  export default Pricing;
  